import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function RequireClientAuth({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    let user = null;
    try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch {}

    const isClient = token && user && (user.role === 'client' || user.role === 'user');

    if (!isClient) {
      localStorage.setItem('redirectAfterLogin', location.pathname);
      navigate('/client/login', {
        state: {
          message: 'Please login or create an account to continue',
          from: location.pathname
        }
      });
    }
  }, [navigate, location]);

  const token = localStorage.getItem('token');
  let user = null;
  try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch {}
  const isClient = token && user && (user.role === 'client' || user.role === 'user');

  if (!isClient) return null;

  return children;
}

export default RequireClientAuth;
